// Types for Asset Monitoring
export interface AssetRecord {
  id: string;
  assetName: string;
  assetCode: string;
  description?: string;
  category: string;
  status: string;
  location?: string;
  assignedTo?: string;
  purchaseDate?: Date;
  warrantyExpiry?: Date;
  maintenanceSchedule?: Date;
  lastMaintenanceDate?: Date;
  notes?: string;
  company: string; // For company-based filtering
  created_at: Date;
  updated_at: Date;
  created_by: string;
  updated_by: string;
  value?: string | number; // Asset value/amount
  image?: string; // URL to the asset image
}

export interface AssetSearchFilters {
  company?: string;
  assetName?: string;
  assignedTo?: string;
  category?: string;
  status?: string;
}

// Common asset categories
export const ASSET_CATEGORIES = [
  'Vehicles',
  'Office Equipment',
  'Technology',
  'Furniture',
  'Tools',
  'Safety Equipment',
  'Other'
] as const;

// Common asset statuses

export const ASSET_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'maintenance', label: 'Maintenance' },
  { value: 'retired', label: 'Retired' },
  { value: 'lost-stolen', label: 'Lost/Stolen' }
] as const;

export type AssetCategory = typeof ASSET_CATEGORIES[number];
export type AssetStatus = typeof ASSET_STATUSES[number]['value'];
